import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  limit,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";
import type { Yard } from "./types";

export interface UseUserYardResult {
  yard: Yard | null;
  loading: boolean;
  error: Error | null;
}

export function useUserYard(userId: string | null | undefined): UseUserYardResult {
  const [yard, setYard] = useState<Yard | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }
    const q = query(
      collection(db, "yards"),
      where("members", "array-contains", userId),
      limit(1)
    );
    const unsub = onSnapshot(
      q,
      (snap) => {
        if (snap.empty) {
          setYard(null);
        } else {
          const d = snap.docs[0]!;
          setYard({ id: d.id, ...(d.data() as Omit<Yard, "id">) });
        }
        setLoading(false);
      },
      (err) => {
        setError(err as Error);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [userId]);

  return { yard, loading, error };
}
